import { Uploader } from '@syncfusion/ej2-inputs';

import { Grid, Filter, Page, Sort, RecordClickEventArgs } from '@syncfusion/ej2-grids';
import { Query, DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { closest } from '@syncfusion/ej2-base';

export class CompanyDetailManager {

    constructor(private containerElement: JQuery) { }

    private companyDatabaseInfoContainer : JQuery<HTMLElement>;
    private companyErpDataHubInfoContainer : JQuery<HTMLElement>;

    private logItemsTabContent : JQuery<HTMLElement>;
    private currentTab : string;

    public initialize() {
        var self = this;

        self.companyDatabaseInfoContainer = self.containerElement.find('#company-database-body');
        self.companyErpDataHubInfoContainer = self.containerElement.find('#company-erp-data-hub-body');

        self.logItemsTabContent = self.containerElement.find('#log-items-tab-content');

        self.loadDatabasesInfo()

        self.bindTabList();
    }

    //#region Database info
    private loadDatabasesInfo() {
        var self = this;

        self.companyDatabaseInfoContainer.load('?handler=CompanyDatabaseInfo', () => {
            self.initializeCreateCompanyDatabase();
        });

        (<any>window).initializeCreateCompanyDatabase = () => {
            self.initializeCreateCompanyDatabase();
        }

        self.companyErpDataHubInfoContainer.load('?handler=CompanyErpDataHubDatabaseInfo', () => {
            self.initializeCreateErpDataHubDatabase();
            
        });

        (<any>window).initializeCreateErpDataHubDatabase = () => {
            self.initializeCreateErpDataHubDatabase();
        }
    }

    private initializeCreateCompanyDatabase() {
        console.log('comp info');
    }

    private initializeCreateErpDataHubDatabase() {
        console.log('comp erp info');
    }

    //#endregion

    //#region TabList
    private bindTabList() {
        var self = this;
        var selectTab = (target) => {
            self.currentTab = target;

            switch (target) {
                case '#log-items-tab-content':
                    this.initializeLogItemsTab();
                    break;
            }
        }

        this.containerElement.find('button[data-bs-toggle="tab"]').on('shown.bs.tab',
            e => {
                selectTab($(e.target).data('bs-target'));
            }
        );

        this.containerElement.find('div.tab-pane').each((index, element) => {
            var tabPane = $(element);
            if(tabPane.hasClass('active')) {
                selectTab(`#${tabPane.attr("id")}`);
            }
        })
    }

    private initializeLogItemsTab() {
        var self = this;

        self.logItemsTabContent.load('?handler=LogItems', () => {

        });
    }

    //#endregion
}